import { useQuery } from '@tanstack/react-query';

import { getAdminAccount } from 'api/adminAccounts';
import { queryKeys } from 'constants/queryKeys';
import { accountManagementStrings } from 'constants/strings';
import { useAuth } from 'contexts/AuthContext';
import type { TAdminAccount } from 'types';
import { toErrorMessage } from './utils';

type UseAdminAccountResult = {
  account: TAdminAccount | undefined;
  loading: boolean;
  error: string | undefined;
};

export function useAdminAccount(accountId?: number): UseAdminAccountResult {
  const { user } = useAuth();
  const strings = accountManagementStrings.edit;

  const query = useQuery({
    queryKey: [queryKeys.ADMIN_ACCOUNT_DETAIL, accountId, user?.uid],
    enabled: Boolean(user?.uid && accountId !== undefined),
    queryFn: () => {
      if (accountId === undefined) {
        throw new Error(strings.errors.loadFailed);
      }
      return getAdminAccount(accountId);
    },
    retry: false,
  });

  return {
    account: query.data,
    loading: Boolean(user?.uid && accountId !== undefined) && query.isPending,
    error: query.error
      ? toErrorMessage(query.error, strings.errors.loadFailed)
      : undefined,
  };
}
